const adminLogin = {
  data: [],
  status: 'idle',
  error: ''
};

const getInvestmentStatementReducer = (state = adminLogin, action) => {
  switch (action.type) {
    case 'GET_INVESTMENT_STATEMENT_LIST_REQUEST':
      return {
        ...state,
        status: 'pending'
      };
    case 'GET_INVESTMENT_STATEMENT_LIST_FAILURE':
      return {
        ...state,
        status: 'rejected',
        error: action.payload
      };
    case 'GET_INVESTMENT_STATEMENT_LIST_SUCCESS':
      return {
        ...state,
        status: 'resolve',
        data: action.payload.data
      };
    case 'RESET_INVESTMENT_STATEMENT_LIST_LIST':
      return {
        ...state,
        ...adminLogin
      };
    default:
      return state;
  }
};

const getInvestmentStatmentDetailReducer = (state = adminLogin, action) => {
  switch (action.type) {
    case 'GET_INVESTMENT_STATEMENT_DETAIL_REQUEST':
      return {
        ...state,
        status: 'pending'
      };
    case 'GET_INVESTMENT_STATEMENT_DETAIL_FAILURE':
      return {
        ...state,
        status: 'rejected',
        error: action.payload
      };
    case 'GET_INVESTMENT_STATEMENT_DETAIL_SUCCESS':
      return {
        ...state,
        status: 'resolve',
        data: action.payload.data
      };
    case 'RESET_INVESTMENT_STATEMENT_DETAIL_LIST':
      return {
        ...state,
        ...adminLogin
      };
    default:
      return state;
  }
};

export { getInvestmentStatementReducer, getInvestmentStatmentDetailReducer };
